import React from 'react'
import { Swiper } from 'antd-mobile'
import { handleCovertPhone } from '../../../utils'

class TurntableCarousel extends React.PureComponent {
  state = {
    data: []
  }
  getData = () => {
    let config = {
      url: window.API.Turntable.getLotteryUser,
      params: {
        pageIndex: 1,
        pageSize: 10
      }
    }
    window.axios.request(config)
      .then(res => {
        this.setState({
          data: res.map(item => {
            return {
              covertPhone: handleCovertPhone(item['phone']),
              ...item
            }
          })
        })
      })
      .catch(error => {})
  }

  componentDidMount () {
    this.getData()
  }

  render () {
    const { data } = this.state
    return <div className={'turntable__carousel'}>
      {
        data.length > 0
          ? <Swiper
            direction={'vertical'}
            indicator={false}
            allowTouchMove={false}
            autoplay
            loop
          >
            {data.map(item => {
              return <Swiper.Item key={item['id']}>
                <div className="turntable__carousel__item">
                  <i className={'icon-font icon-notification2'} />&emsp;
                  恭喜 {item['covertPhone']} 获得 {item['giftDesc']}
                </div>
              </Swiper.Item>
            })}
          </Swiper>
          : null
      }
    </div>
  }
}

export default TurntableCarousel
